(function() {
    'use strict';

    angular.module('montage.constants', [])
        .constant('montageMessagesConst', {
            add: 'Dodano nowy montaż!',
            update: 'Dane montażu zostały zaktualizowane!',
            delete: 'Montaż został usunięty!',
            duplicated: 'Montaż został zduplikowany!',
            closed: 'Montaż został zamknięty.',
            unclosed: 'Montaż został otwarty.',
            printed: 'Montaż został wydrukowany.',
            unprinted: 'Wydrukowanie montażu zostało cofnięte.',
            mounted: 'Montaż został zmontowany.',
            unmounted: 'Montowanie montażu zostało cofnięte.',
            radiated: 'Montaż został naświetlony.',
            unradiated: 'Naświetlenie montażu zostało cofnięte.',
            error: 'Wystąpił bład!'
        })
        .constant('montageProductMessagesConst', {
            update: 'Dane zlecenia zostały zaktualizowane!',
            error: 'Wystąpił bład!'
        })
        .constant('montageStateOptionsConst', {
            true: {
                value: 'True',
                title: 'Tak'
            },
            false: {
                value: 'False',
                title: 'Nie'
            },
        })
        .constant('montageOrderStatusesConst', [{
            title: 'Oczekuje na płatność',
            value: 'waiting_for_payment'
        }, {
            title: 'W realizacji',
            value: 'in_realization'
        }, {
            title: 'W produkcji',
            value: 'in_production'
        }])
        .constant('rwStatusesConst', [{
            title: 'Oczekuje na wystawienie RW',
            value: 'awaiting'
        }, {
            title: 'RW wystawione automatycznie',
            value: 'auto_issued'
        }, {
            title: 'RW wystawione ręcznie',
            value: 'manual_issued'
        }, {
            title: 'RW niewystawione automatycznie',
            value: 'auto_not_issued'
        }])
        .constant('montagePermissionsConst', {
            view: {
                value: 'view_montage',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu montażu!'
            },
            add: {
                value: 'add_montage',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania montażu!'
            },
            update: {
                value: 'change_montage',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji montażu!'
            },
            delete: {
                value: 'delete_montage',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania montażu!'
            },
            set_closed_montage_permission: {
                value: 'set_closed_montage_permission',
                errorMsg: 'Użytkownik nie ma uprawnień do zamknięcia montażu!'
            },
            set_mounted_montage_permission: {
                value: 'set_mounted_montage_permission',
                errorMsg: 'Użytkownik nie ma uprawnień do zmontowania montażu!'
            },
            set_radiated_montage_permission: {
                value: 'set_radiated_montage_permission',
                errorMsg: 'Użytkownik nie ma uprawnień do naświetlania montażu!'
            },
            set_printed_montage_permission: {
                value: 'set_printed_montage_permission',
                errorMsg: 'Użytkownik nie ma uprawnień do wydrukowania montażu!'
            },
            view_montage_from_sites_permission: {
                value: 'view_montage_from_sites_permission',
                errorMsg: 'Użytkownik nie ma uprawnień do podglądu montażu!'
            }
        });
})();
